module.exports = __webpack_public_path__ + "static/media/fe_mail.fb2c662f.png";